import { render, staticRenderFns } from "./campusCard.vue?vue&type=template&id=be036aae&scoped=true"
import script from "./campusCard.vue?vue&type=script&lang=js"
export * from "./campusCard.vue?vue&type=script&lang=js"
import style0 from "./campusCard.vue?vue&type=style&index=0&id=be036aae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be036aae",
  null
  
)

export default component.exports